module.exports = __webpack_public_path__ + "static/media/error.79d8729c.svg";